import { createContext, useContext } from 'react';
import UAParser                      from "ua-parser-js";

export const getUserAgentData = () => {
  const ua = new UAParser(navigator.userAgent);
  const { device, os, browser } = ua.getResult();

  //To avoid crashes in sw where window is not defined. We use typeof because it does not check the
  //value of a potentially not defined variable
  const is_touch_device = (typeof window !== "undefined" && 'ontouchstart' in window) || navigator.maxTouchPoints > 0;
  const is_apple = device.vendor === 'Apple';

  return {
    device,
    os,
    browser,
    is_touch_device,
    is_mobile: device.type === 'mobile' || device.type === 'smarttv' || device.type === 'wearable',
    is_apple,
    is_android: os.name.search(/Android/gi),
    is_apple_device_installable: is_apple && is_touch_device,
  };
};

export const UserAgentContext = createContext();
export const useUserAgent = () => useContext(UserAgentContext);
